import { render, staticRenderFns } from "./start-tv-modal.vue?vue&type=template&id=0b7d8659&"
import script from "./start-tv-modal.vue?vue&type=script&lang=js&"
export * from "./start-tv-modal.vue?vue&type=script&lang=js&"
import style0 from "./start-tv-modal.vue?vue&type=style&index=0&id=0b7d8659&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports